import { ActionButton, Card, CommandButton, ImageGallery, Modal } from "components";
import { Fragment, useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { TbFileUpload } from "react-icons/tb";
import { useApi, useToggle } from "utils";
import toast from "react-hot-toast";
import { SuccessFetch } from "types";
import { FormCustomerQuotationType } from "../types";

export function AttachmentModal(): JSX.Element {
  const api = useApi() 
  const { isActive, toggle } = useToggle(false)
  const { control, getValues, setValue, watch } = useFormContext<FormCustomerQuotationType>()
  const trx_code = watch('trx_code')

  return (
    <Fragment>
      <CommandButton actiontype="attachment" onClick={toggle} />

      {isActive && (
        <Modal isOpen title="ATTACHMENT" closeModal={toggle}>
          <Modal.Body>
            <UploadFile onSuccess={(result) => setValue("imgPath", [...getValues("imgPath") || [], result])} />

            <Controller
              control={control}
              name="imgPath"
              render={({ field, fieldState }) => (
                <section ref={field.ref}>
                  <FileList
                    label={trx_code}
                    error={fieldState.error?.message}
                    items={field.value!}
                    onDelete={(item, key) => {
                      const data = [...field.value!]
                      data.splice(key, 1)
                      field.onChange(data)    
                        
                      api.post(`/customer-quotation/removefile?strPath=${item.file_path}`)
                    }}
                  />
                </section>
              )}
            />
          </Modal.Body>
        </Modal>
      )}
    </Fragment>
  )
}

function UploadFile(props: { onSuccess: (result: { file_path: string }) => void }) {
  const api = useApi()
  const fileRef = useRef<HTMLInputElement>(null)
  const { isActive, toggle } = useToggle(false)

  const onUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      toggle()

      toast.promise(api.postForm('/customer-quotation/uploadfile', { fileupload: e.target.files[0] }), {
        loading: "Loading...",
        success: (res) => res.data.message,
        error: (err) => err.response.data.message ?? err.response.message
      })
      .then((res: SuccessFetch<{ payload: { namafile: string } }>) => {
        props.onSuccess({ file_path: res.data.payload.namafile })
        if (fileRef.current) { fileRef.current.value = "" }
      })
      .catch(console.error)
      .finally(toggle)
    }
  }

  return (
    <Fragment>
      <input
        type="file"
        hidden
        id="file-upload"
        ref={fileRef}
        onChange={onUpload}
      />

      <label htmlFor="file-upload" className="w-fit btn btn-primary rounded-none di">
        {isActive && <span className="loading loading-spinner" />}
        <TbFileUpload size={24} /> UPLOAD FILE
      </label>
    </Fragment>
  )
}


function FileList(props: {
  error: string | undefined
  items: { file_path: string }[]
  label: string | undefined
  onDelete: (value: { file_path: string }, key: number) => void
}) {
  const [activeIndex, setIndex] = useState<number | null>(null)
  console.log(props.items)

  return (
    <Fragment>
      {props?.items?.map((item, key) => {
        return (
          <section key={key} className="w-full md:max-w-[300px] my-3">
            <Card>
              <Card.Body className="flex flex-row justify-between">
                <div className="truncate cursor-pointer" onClick={() => setIndex(key)}>
                  {props.label}-{(key + 1).toString().padStart(2, "0")}
                </div>

                <ActionButton.Delete onClick={() => props.onDelete(item, key)} />
              </Card.Body>
            </Card>
          </section>
        )
      })}

      {props.error && (
        <label className="label">
          <span className="label-text-alt font-bold text-error">{props.error}</span>
        </label>
      )}

      {activeIndex != null && (
        <ImageGallery
          isOpen
          activeIndex={activeIndex}
          onClose={() => setIndex(null)}
          images={props.items.map(item => {
            return { src: `${process.env.REACT_APP_BASE_URL_API}/getimage/?imgpath=${item.file_path}` }
          })}
        />
      )}
    </Fragment>
  )
}